import { ImportedGood } from '@/features/cbam-reporting/hooks/importedGoods'

export type ImportedGoodEligibilityStatus = 'COMPLETE' | 'INCOMPLETE'

export type ImportedGoodEligibilityResult = {
  status: ImportedGoodEligibilityStatus
  missingFields: string[]
}

export function getImportedGoodEligibility(
  importedGood: ImportedGood,
  isRepresentative: boolean
): ImportedGoodEligibilityResult {
  const missingFields: string[] = []

  if (!importedGood.cnCode || importedGood.cnCode.trim() === '') {
    missingFields.push('cnCode')
  }

  if (importedGood.netMassInTonnes === undefined || importedGood.netMassInTonnes === null) {
    missingFields.push('netMassInTonnes')
  }

  if (!importedGood.country || importedGood.country.trim() === '') {
    missingFields.push('country')
  }

  if (isRepresentative && !importedGood.importerId) {
    missingFields.push('importerId')
  }

  if (!importedGood.partnershipId) {
    missingFields.push('partnershipId')
  }

  if (!importedGood.installationId) {
    missingFields.push('installationId')
  }

  if (!importedGood.isUsingDefaultEmissions && !importedGood.supplierEmissionsReportId) {
    missingFields.push('supplierEmissionsReportId')
  }

  if (
    !importedGood.requestedCustomsProcedure ||
    importedGood.requestedCustomsProcedure.trim() === ''
  ) {
    missingFields.push('requestedCustomsProcedure')
  }

  return {
    status: missingFields.length === 0 ? 'COMPLETE' : 'INCOMPLETE',
    missingFields
  }
}

export function areAllImportedGoodsEligible(
  importedGoods: ImportedGood[],
  isRepresentative: boolean
): boolean {
  return importedGoods.every(
    importedGood => getImportedGoodEligibility(importedGood, isRepresentative).status === 'COMPLETE'
  )
}
